import { render } from "./edit.vue?vue&type=template&id=a26467ea&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=a26467ea&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a26467ea"],['__file',"src/views/people/level/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a26467ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a26467ea', __exports__)) {
    console.log('reload')
    api.reload('a26467ea', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=a26467ea&scoped=true", () => {
    console.log('re-render')
    api.rerender('a26467ea', render)
  })

}


export default __exports__